import { React, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { useParams } from "react-router";

import { Button } from "../../commonComponents/Buttons";
import { QuatroGrid } from "../../commonComponents/Grids";

import usersService from "../../../services/userService";
import {
  get_channels_list,
  get_more_channels_list,
  get_restrict_channels_list,
  get_more_restrict_channels_list,
  add_channel_subscriber,
} from "../../../redux/features/ktkSlice";

import { CoinIcon, SubscribedButton, ViewsIcon, UnsubscribedButton, NoAvatar, ReplyButton, ReplyButton3 } from "../../../assets";

import "./kidsTeachKids.scss";

function ChannelsList() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const params = useParams();
  const channelsListInfo = useSelector((state) => state?.ktk?.channelsList);
  const [channelsList, setChannelsList] = useState();
  const userInfoLevel = useSelector((state) => state?.user?.userInfo?.account_level);

  useEffect(() => {
    if (!channelsList) {
      if (userInfoLevel && userInfoLevel === "user") {
        dispatch(get_channels_list()).then((result) =>
          setChannelsList(result?.payload?.data)
        );
      }

      if (userInfoLevel && userInfoLevel === "manager") {
        dispatch(get_restrict_channels_list(params?.userId)).then((result) =>
        {
          setChannelsList(result?.payload?.data)
        }
        );
      }
    }
  }, [channelsList, dispatch, params, userInfoLevel]);
  function handleSubscribe(channelId) {
    dispatch(add_channel_subscriber(channelId))
      .unwrap()
      .then((response) => {
        setChannelsList((prevList) =>
          prevList.map((channel) => {
            if (channel.id === channelId) {
              const updated = {
                ...channel,
                subscriber_count: response.subscriber_count,
                is_subscribed: response.is_subscribed,
              };
              return updated;
            }
            return channel;
          })
        );
      })
      .catch((error) => {
        console.error("Error toggling subscriber:", error);
      });
  }

  function loadMore() {
    if (userInfoLevel && userInfoLevel === "user") {
      dispatch(get_more_channels_list(channelsListInfo?.next_page)).then(
        (result) => {
          setChannelsList(channelsList.concat(result?.payload?.data));
        }
      );
    }

    if (userInfoLevel && userInfoLevel === "manager") {
      let args = {
        userId: params?.userId,
        page: channelsListInfo?.next_page,
      };
      dispatch(get_more_restrict_channels_list(args)).then((result) => {
        setChannelsList(channelsList.concat(result?.payload?.data));
      });
    }
  }

  function renderTitle() {
    if (userInfoLevel && userInfoLevel === "user") {
      return t("ktk");
    } else if (userInfoLevel && userInfoLevel === "manager") {
      return t("channelRestrict");
    }
  }

  return (
    <>
      <main className="ktkBg">
        <Button
          label={t("back")}
          iconClassName="hasIcon--chevron-left"
          viewType="backButton"
          onClick={() => usersService.goToMonolith("dashboard/")}
        />
      <QuatroGrid
        title={renderTitle()}
        viewType="wide"
        ifPagination={channelsListInfo?.next_page ? true : false}
        paginationClick={loadMore}
      >

          {channelsListInfo &&
            !channelsListInfo.has_channel &&
            userInfoLevel === "user" && (
              <li>
                <NavLink
                  to="/kids-teach-kids/channel-management"
                  className="addChannelBtn"
                >
                  <p className="btnTxt">+{t("startMyChannel")}</p>
                </NavLink>
              </li>
            )}{channelsList &&
          channelsList.map((item) => (
            <li key={item?.id} className="channelListItem">
              <NavLink
                to={
                  userInfoLevel === "user"
                    ? `/kids-teach-kids/channel/${item?.id}`
                    : `/kids-teach-kids/channels/${params?.userId}/channel/${item?.id}`
                }
                className={`channelCard ${item?.user?.request_user && "ownerBorder"}`}
              > 
                {userInfoLevel === "user" && (
                  item.user.request_user ? (
                    item.has_new_comment ? (
                      <img
                        className="subscribeButton"
                        src={ReplyButton}
                        alt="New comment"
                      />
                    ) : (
                      <img
                        className="subscribeButton"
                        src={ReplyButton3}
                        alt="No new comment"
                      />
                    )
                  ) : (
                    <img
                      onClick={() => handleSubscribe(item.id)}
                      className="subscribeButton"
                      src={item.is_subscribed ? SubscribedButton : UnsubscribedButton}
                      alt={item.is_subscribed ? "Unsubscribe" : "Subscribe"}
                    />
                  )
                )}

                {item?.new_video && <div className="newLabel">{t("newVideo")}</div>}
                <img
                  className="channelImage"
                  src={item?.channel_avatar ? item?.channel_avatar : NoAvatar}
                  alt={item?.title}
                />
                <p className="channelOwner">
                  {item?.user?.name}, {item?.user?.age ? item?.user?.age : "?"} y.o.{" "}
                  {item?.user?.request_user && `(${t("youLower")})`}
                </p>
                <p className="channelTitle">{item?.title}</p>
                <section className="infoSection">
                  <span className="subscriberCount">
                    <img className="subscribeButtonIcon" src={SubscribedButton} alt={t("videos")}/>
                    {item?.subscriber_count}
                  </span>
                  <span className="viewCount">
                    <img className="viewsIcon" src={ViewsIcon} alt={t("videos")}/>
                    {item?.views_count}
                  </span>
                  <div className="pointCounter">
                    <img className="videoIcon" src={CoinIcon} alt={t("points")} />
                    <span className="earnedPointsCount">
                      {!item?.user?.request_user && userInfoLevel === "manager" ? 0 : item?.earned_points}
                    </span>
                    <span className="maxPointsCount">
                      /{item?.videos_count}
                    </span>
                  </div>
                </section>
              </NavLink>
            </li>
          ))}
      </QuatroGrid>

      </main>
      {userInfoLevel && userInfoLevel === "manager" && (
        <section className="manageRestrictSubmit">
          <ul>
            <li>
              {t("restrictLabelTo")}{" "}
              <strong>{channelsListInfo?.kid_name}</strong>:
            </li>
            <li>
              <Button
                label={t("done")}
                viewType="mainBtn"
                onClick={() => usersService.goToMonolith("accounts/readers/")}
              />
            </li>
          </ul>
        </section>
      )}
    </>
  );
}

export default ChannelsList;
